import Vue from 'vue'
import Router from 'vue-router'
import { Indicator } from 'mint-ui';
const test1 = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/test1')); Indicator.close() }, 'test1') }
const test2 = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/test2')); Indicator.close() }, 'test2') }
const test3 = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/test3')); Indicator.close() }, 'test2') }

const ErrorPage = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/error/error')); Indicator.close() }, 'ErrorPage') } //错误页面
const Lead = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/lead/index')); Indicator.close() }, 'Lead') }
const Index = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/index')); Indicator.close() }, 'Agent') }
const Order = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/order/index')); Indicator.close() }, 'Order') }
const Team = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/team/index')); Indicator.close() }, 'Team') }
const TeamInfo = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/team/info/index')); Indicator.close() }, 'TeamInfo') }
const TeamNum = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/team/teamNum/index')); Indicator.close() }, 'TeamNum') }
const TeamNewAdd = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/team/teamNewAdd/index')); Indicator.close() }, 'TeamNewAdd') }
const TeamAchievement = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/team/teamAchievement/index')); Indicator.close() }, 'TeamAchievement') }
const TeamAchievementInfo = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/team/teamAchievementInfo/index')); Indicator.close() }, 'TeamAchievementInfo') }
const TeamAgentType = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/team/teamAgentType/index')); Indicator.close() }, 'TeamAgentType') }
const MyHome = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/index')); Indicator.close() }, 'My') }
const AgentHome = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/agent/index')); Indicator.close() }, 'AgentHome') }
const Address = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/address/index')); Indicator.close() }, 'Address') }
const ApplyStep1 = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/apply/step1/index')); Indicator.close() }, 'Apply') }
const ApplyStep2 = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/apply/step2/index')); Indicator.close() }, 'Apply') }
const ApplyStep3 = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/apply/step3/index')); Indicator.close() }, 'Apply') }
const ApplyStep4 = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/apply/step4/index')); Indicator.close() }, 'Apply') }
const ApplyStep5 = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/apply/step5/index')); Indicator.close() }, 'Apply') }
const Invite = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/invite/index')); Indicator.close() }, 'Invite') }
const Audit = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/audit/index')); Indicator.close() }, 'Audit') }
const Reward = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/reward/index')); Indicator.close() }, 'Reward') }
const Achievement = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/achievement/index')); Indicator.close() }, 'Achievement') }
const AchievementDatails = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/achievement/details/index')); Indicator.close() }, 'AchievementDatails') }
const Relative = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/relative/index')); Indicator.close() }, 'Relative') }
const Invrelative = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/invrelative/index')); Indicator.close() }, 'Invrelative') }
const Auth = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/auth/index')); Indicator.close() }, 'Auth') }
const AuthList = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/auth/authList/index')); Indicator.close() }, 'AuthList') }
const AddAuth = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/auth/addAuth/index')); Indicator.close() }, 'AddAuth') }
const AuthSuccess = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/auth/authSuccess/index')); Indicator.close() }, 'AddAuAuthSuccessth') }
const Shop = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/shop/index')); Indicator.close() }, 'Shop') }
const ShopAuthList = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/shop/authList/index')); Indicator.close() }, 'Shop') }
const SubmitOrders = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/shop/submitOrders/index')); Indicator.close() }, 'SubmitOrders') }
const SubmitSuccess = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/shop/SubmitSuccess/index')); Indicator.close() }, 'SubmitSuccess') }
const Login = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/login/index')); Indicator.close() }, 'Login') }
const Register = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/login/register')); Indicator.close() }, 'Login') }
const ForgotPassword = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/login/forgotpassword')); Indicator.close() }, 'Login') }
const AddBrandStep1 = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/agent/addbrand/addbrandstep1')); Indicator.close() }, 'AddBrand') }
const AddBrandStep2 = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/agent/addbrand/addbrandstep2')); Indicator.close() }, 'AddBrand') }
const AddBrandStep3 = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/agent/addbrand/addbrandstep3')); Indicator.close() }, 'AddBrand') }
const AddBrandStep4 = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/agent/addbrand/addbrandstep4')); Indicator.close() }, 'AddBrand') }
const SetUp = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/setUp/index')); Indicator.close() }, 'SetUp') }
const MyInfo = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/info/index')); Indicator.close() }, 'MyInfo') }
const UpdatePwd = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/updatePwd/index')); Indicator.close() }, 'UpdatePwd') }
const MyAddress = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/address/index')); Indicator.close() }, 'MyAddress') }
const AddAddress = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/address/add/index')); Indicator.close() }, 'AddAddress') }
const UpdateAddress = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/address/update/index')); Indicator.close() }, 'UpdateAddress') }
const MyBank = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/bank/index')); Indicator.close() }, 'MyBank') }
const AddMyBank = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/bank/add/index')); Indicator.close() }, 'AddMyBank') }
const MyPayment = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/payment/index')); Indicator.close() }, 'MyPayment') }
const MyAlipay = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/alipay/index')); Indicator.close() }, 'MyAlipay') }
const AddAlipay = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/alipay/add/index')); Indicator.close() }, 'AddAlipay') }
const WeChat = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/weChat/index')); Indicator.close() }, 'WeChat') }
const AddWeChat = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/weChat/add/index')); Indicator.close() }, 'AddWeChat') }
const Transfer = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/transfer/index')); Indicator.close() }, 'Transfer') }
const TransferDetails = r => { Indicator.open(); require.ensure([], () => { r(require('@/components/index/my/transfer/detail/index')); Indicator.close() }, 'TransferDetails') }
const TransferSuccess = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/subTransfer/transfersuccess')); Indicator.close() }, 'Transfer') }
const MyAuth = r => { Indicator.open(); require.ensure([], () => { r(require('@/components/index/my/auth/index')); Indicator.close() }, 'MyAuth') }
const MyOrders = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/myOrders/index')); Indicator.close() }, 'MyOrders') }
const InternalOrders = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/internalOrders/index')); Indicator.close() }, 'InternalOrders') }		
const InternalShop = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/internalShop/index')); Indicator.close() }, 'InternalShop') }
const SubOrders = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/subOrders/index')); Indicator.close() }, 'SubOrders') }//下级进货订单
const TwosubOrders = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/order/twoSubOrders/index')); Indicator.close() }, 'TwosubOrders') }   //下级订单
const TeamsubOrders = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/order/teamSubOrders/index')); Indicator.close() }, 'TeamsubOrders') } //团队订单
const OrderDetails = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/orderDetails/index')); Indicator.close() }, 'OrderDetails') }
const Message = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/message/index')); Indicator.close() }, 'Message') }     //消息页面
const Messagedetail = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/message/messagedetail')); Indicator.close() }, 'Message') }     //系统消息详情页面
const Updaterecord = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/updaterecord/index')); Indicator.close() }, 'Updaterecord') }     //我的升级记录
const Cashdeposit = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/cashdeposit/index')); Indicator.close() }, 'Cashdeposit') } //保证金
const PayCashdeposit = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/cashdeposit/payindex')); Indicator.close() }, 'Cashdeposit') } //缴纳保证金
const UploadCashdeposit = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/cashdeposit/upload')); Indicator.close() }, 'Cashdeposit') } //保证金上传凭证页面
const Myshop = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/myshop/index')); Indicator.close() }, 'Myshop') } //我的小店主页
const MyshopBuy = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/myshop/buyindex')); Indicator.close() }, 'Myshop') } //我的购买主页
const Clock = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/myshop/clock/clock')); Indicator.close() }, 'Myshop') } //我的小店秒杀
const ClockEdit = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/myshop/clock/clockedit')); Indicator.close() }, 'Myshop') } //我的小店秒杀编辑
const Bargain = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/myshop/bargain/bargain')); Indicator.close() }, 'Myshop') } //我的小店砍价
const BargainEdit = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/myshop/bargain/bargainedit')); Indicator.close() }, 'Myshop') } //我的小店砍价
const GroupShopping = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/myshop/groupshopping/groupshopping')); Indicator.close() }, 'Myshop') } //我的小店拼团
const GroupShoppingEdit = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/myshop/groupshopping/groupshoppingedit')); Indicator.close() }, 'Myshop') } //我的小店拼团编辑
const ProductDetail = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/myshop/productdetail')); Indicator.close() }, 'Myshop') } //我的小店商品详情
const ProductDetailGroupShopping = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/myshop/productdetailgroupshopping')); Indicator.close() }, 'Myshop') } //我的小店活动团购
const ProductDetailClock = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/myshop/productdetailclock')); Indicator.close() }, 'Myshop') } //我的小店活动秒杀
const ProductDetailBargain = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/myshop/productdetailbargain')); Indicator.close() }, 'Myshop') } //我的小店活动砍价
const MyshopSubmitOrders = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/myshop/submitorders/submitorders')); Indicator.close() }, 'Myshop') } //我的小店订单提交页
const MyshopSubmitOrdersSuccess = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/myshop/submitorders/submitsuccess')); Indicator.close() }, 'Myshop') } //我的小店订单提交页
const MyshopAddress = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/myshop/address/index')); Indicator.close() }, 'Myshop') } //我的小店收货地址页面
const MyshopAddressAdd = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/myshop/address/add')); Indicator.close() }, 'Myshop') } //我的小店收货地址增加页面
const MyshopAddressUpdate = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/myshop/address/update')); Indicator.close() }, 'Myshop') } //我的小店收货地址编辑页面
const Remind = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/agent/remind/index')); Indicator.close() }, 'Agent') } //主页跳转 待办提醒
const Promote = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/agent/promote/index')); Indicator.close() }, 'Promote') } //推广
const PromoteDetail = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/agent/promote/promotedetail')); Indicator.close() }, 'Promote') } //推广详情
const SourceCenter = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/agent/sourcecenter/index')); Indicator.close() }, 'Promote') } //素材中心
const SourceDetail = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/agent/sourcecenter/sourcedetail')); Indicator.close() }, 'Promote') } //素材中心详情
const MySource = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/agent/sourcecenter/mysource')); Indicator.close() }, 'Promote') } //素材中心详情
const Inviteuser = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/invite/inviteuser/index')); Indicator.close() }, 'Invite') }
const Stock = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/stock/index')); Indicator.close() }, 'Stock') }
const ActualStockDetail = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/stock/actualStockDetail/index')); Indicator.close() }, 'ActualStockDetail') }
const VirtualStockDetail = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/stock/virtualStockDetail/index')); Indicator.close() }, 'VirtualStockDetail') }
const TakeGoods = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/stock/takeGoods/index')); Indicator.close() }, 'TakeGoods') }
const StockSubmitOrders = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/stock/submitOrders/index')); Indicator.close() }, 'StockSubmitOrders') }
const StockSubmitSuccess = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/stock/submitSuccess/index')); Indicator.close() }, 'StockSubmitSuccess') }
const StockOrderList = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/stock/orderList/index')); Indicator.close() }, 'StockOrderList') }
const AgentQuery = r => { Indicator.open(); require.ensure([], () => { r(require('@/components/agentquery/index')); Indicator.close() }, 'AgentQuery') }
const AgentQueryResult = r => { Indicator.open(); require.ensure([], () => { r(require('@/components/agentquery/result/index')); Indicator.close() }, 'AgentQueryResult') }
const AuditOrders = r => { Indicator.open(); require.ensure([], () => { r(require('@/components/auditOrders/index')); Indicator.close() }, 'AuditOrders') }
const AuditOrdersDetail = r => { Indicator.open(); require.ensure([], () => { r(require('@/components/auditOrders/detail/index')); Indicator.close() }, 'AuditOrdersDetail') }
const Security = r => { Indicator.open(); require.ensure([], () => { r(require('@/components/security/index')); Indicator.close() }, 'Security') }
const SecurityResult = r => { Indicator.open(); require.ensure([], () => { r(require('@/components/security/result/index')); Indicator.close() }, 'SecurityResult') }
const ThirdPartyLogin = r => { Indicator.open(); require.ensure([], () => { r(require('@/components/thirdPartyLogin/index')); Indicator.close() }, 'SecurityResult') }
const MyReward = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/myReward/index')); Indicator.close() }, 'MyReward') }   //我的业绩页面
const QRDelivery = r => { Indicator.open(); require.ensure([], () => { r(require('@/components/qRDelivery/index')); Indicator.close() }, 'QRDelivery') }
const Wallet = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/wallet/index')); Indicator.close() }, 'Wallet') }
const Settlement = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/wallet/settlement/index')); Indicator.close() }, 'Settlement') }
const Recharge = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/wallet/recharge/index')); Indicator.close() }, 'Recharge') }
const Income = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/wallet/income/index')); Indicator.close() }, 'Income') }
const Spending = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/wallet/spending/index')); Indicator.close() }, 'Spending') }
const Upgrade = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/upgrade/index')); Indicator.close() }, 'Upgrade') }
//扫码发货
const SweepCodeDelivery = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/sweepCodeDelivery/index')); Indicator.close() }, 'SweepCodeDelivery') }
const DeliveryRecord = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/sweepCodeDelivery/deliveryRecord/index')); Indicator.close() }, 'DeliveryRecord') }
const DeliveryRecordDetail = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/sweepCodeDelivery/deliveryRecord/deliveryRecordDetail/index')); Indicator.close() }, 'DeliveryRecordDetail') }
const DeliverySelectAgent = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/sweepCodeDelivery/selectAgent')); Indicator.close() }, 'DeliverySelectAgent') }
const DeliveryLogisticsCode = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/sweepCodeDelivery/logisticsCode')); Indicator.close() }, 'DeliveryLogisticsCode') }
const expressInfo = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/sweepCodeDelivery/expressInfo')); Indicator.close() }, 'expressInfo') }
const Report = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/report/index')); Indicator.close() }, 'Report') }
const SubTransfer = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/subTransfer/index')); Indicator.close() }, 'SubTransfer') }
const SubTransferAgents = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/subTransfer/agents/index')); Indicator.close() }, 'SubTransferAgents') }
const SubTransferAudit = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/subTransferAudit/index')); Indicator.close() }, 'SubTransferAudit') }
const MonthReward = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/reward/monthReward/index')); Indicator.close() }, 'MonthReward') }
const OnceReward = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/reward/onceReward/index')); Indicator.close() }, 'OnceReward')}
const UpgradeReward = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/reward/upgradeReward/index')); Indicator.close() }, 'UpgradeReward')} //升级奖励信息
const TopLevelPushReward = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/reward/topLevelPushReward/index')); Indicator.close() }, 'TopLevelPushReward')} //顶级平推奖励信息
const NoTopLevelPushReward = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/reward/noTopLevelPushReward/index')); Indicator.close() }, 'NoTopLevelPushReward')} //非顶级平推奖励信息
const OrderReward = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/reward/orderReward/index')); Indicator.close() }, 'OrderReward') }
const SpendingReward = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/reward/spendingReward/index')); Indicator.close() }, 'SpendingReward') }
const WithdrawalReward = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/reward/withdrawalReward/index')); Indicator.close() }, 'WithdrawalReward') }
const Withdrawal = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/reward/withdrawal/index')); Indicator.close() }, 'Withdrawal') }
const PaymentCert = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/subTransferAudit/paymentCert/index')); Indicator.close() }, 'PaymentCert') }
const WalletWithdrawal = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/wallet/withdrawal/index')); Indicator.close() }, 'WalletWithdrawal') }
//代理商个人信息
const agentInfo = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/audit/agentInfo')); Indicator.close() }, 'agentInfo') }
//实名认证
const Certification = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/certification')); Indicator.close() }, 'Crtification') }
const CertificationInfo = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/certification/info/index')); Indicator.close() }, 'certificationInfo') }
//微信解绑
const DelOpenid = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/setUp/delWxOpenid')); Indicator.close() }, 'DelOpenid') }
//箱码查询
const searchAnticodeCode = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/searchAnticodeCode/searchAnticodeCode')); Indicator.close() }, 'searchAnticodeCode') }
//产品报价单
const SkuPriceSheet = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/skuPriceSheet/index')); Indicator.close() }, 'SkuPriceSheet') }
const ShareSkuPriceSheet = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/skuPriceSheet/share')); Indicator.close() }, 'ShareSkuPriceSheet') }
//物流信息
const OrderLogistics = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/OrderLogistics/index')); Indicator.close() }, 'OrderLogistics') }

//物流信息
const TeamRank = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/team/rank')); Indicator.close() }, 'Team') }
//代理授权展期
const ResetAuth = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/auth/resetAuth/index')); Indicator.close() }, 'ResetAuth') }
//下级订单详情
const SubOrderDetails = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/subOrders/SubOrderDetails')); Indicator.close() }, 'SubOrderDetails') }
//下级订单扫码发货
const SubQRDelivery = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/index/my/subOrders/SubQRDelivery')); Indicator.close() }, 'SubQRDelivery') }
//月结账单
const MonthlySettlement = r => { Indicator.open(); require.ensure([], () => { r(require('@/view/monthlySettlement/index')); Indicator.close() }, 'MonthlySettlement') }

Vue.use(Router)
var title = "AGENT";
export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/monthlySettlement',   //切图1
      meta: {
        title: "MonthlySettlement",
      },
      component: MonthlySettlement
    },
    {
      path: '/test1',   //切图1
      meta: {
        title: "test1",
      },
      component: test1
    },
    {
      path: '/test2',   //切图2
      meta: {
        title: "test2",
      },
      component: test2
    },
    {
      path: '/test3',   //切图3
      meta: {
        title: "test3",
      },
      component: test3
    },
    {
      path: '/SubQRDelivery',   //下级订单扫码发货
      meta: {
        title: "SubQRDelivery",
      },
      component: SubQRDelivery
    },
    {
      path: '/SubOrderDetails',   //下级订单详情
      meta: {
        title: "SubOrderDetails",
      },
      component: SubOrderDetails
    },
    {
      path: '/ResetAuth',   //代理授权展期
      meta: {
        title: "ResetAuth",
      },
      component: ResetAuth
    },
    {
      path: '/TeamRank',   //小店-地址更新
      meta: {
        title: "TeamRank",
      },
      component: TeamRank
    },
    {
      path: '/errorpage',   //小店-地址更新
      meta: {
        title: "ErrorPage",
      },
      component: ErrorPage
    },
    {
      path: '/tokenLogin',
      meta: {
        requireAuth: false, // 判断是否需要登录
        title: "ThirdPartyLogin",
      },
      component: ThirdPartyLogin
    },
    {
      path: '/login',
      meta: {
        requireAuth: false, // 判断是否需要登录
        title: "Login",
      },
      component: Login
    },
    {
      path: '/register',
      meta: {
        requireAuth: false, // 判断是否需要登录
        title: "Register",
      },
      component: Register
    },
    {
      path: '/forgotpassword',
      meta: {
        requireAuth: false, // 判断是否需要登录
        title: "ForgotPassword",
      },
      component: ForgotPassword
    },
    {
      path: '/addbrandstep1',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "AddBrandStep",
      },
      component: AddBrandStep1
    },
    {
      path: '/addbrandstep2',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "AddBrandStep",
      },
      component: AddBrandStep2
    },
    {
      path: '/addbrandstep3',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "AddBrandStep",
      },
      component: AddBrandStep3
    },
    {
      path: '/addbrandstep4',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "AddBrandStep",
      },
      component: AddBrandStep4
    },
    {
      path: '/shop',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "Shop",
      },
      component: Shop
    },
    {
      path: '/shopAuthList',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "Shop",
      },
      component: ShopAuthList
    },
    {
      path: '/submitOrders',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "SubmitOrders",
      },
      component: SubmitOrders
    },
    {
      path: '/SubmitSuccess',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "SubmitSuccess",
      },
      component: SubmitSuccess
    },
    {
      path: '/auth',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "Auth",
      },
      component: Auth
    },
    {
      path: '/authList',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "AuthList",
      },
      component: AuthList
    },
    {
      path: '/addAuth',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "AddAuth",
      },
      component: AddAuth
    },
    {
      path: '/authSuccess',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "AuthSuccess",
      },
      component: AuthSuccess
    },
    {
      path: '',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: title,
      },
      redirect: "/index"
    },
    {
      path: '/invrelative',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "Invrelative",
      },
      component: Invrelative,
    },
    {
      path: '/relative',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "Relative",
      },
      component: Relative,
    },
    {
      path: '/achievement',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "Achievement",
      },
      component: Achievement,
    },
    {
      path: '/reward',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "Reward",
      },
      component: Reward,
    },
    {
      path: '/audit',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "Audit",
      },
      component: Audit,
    },
    {
      path: '/agentInfo',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "agentInfo",
      },
      component: agentInfo,
    },
    {
      path: '/invite',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "Invite",
      },
      component: Invite,
    },
    {
      path: '/inviteuser',
      meta: {
        title: "Inviteuser",
        requireAuth: true, // 判断是否需要登录
      },
      component: Inviteuser,
    },
    {
      path: '/address',
      meta: {
        title: "Address",
        requireAuth: true, // 判断是否需要登录
      },
      component: Address,
    },
    {
      path: '/applyStep1',
      meta: {
        title: "ApplyStep1",
      },
      component: ApplyStep1
    },
    {
      path: '/applyStep2',
      meta: {
        title: "ApplyStep2",
      },
      component: ApplyStep2
    },
    {
      path: '/applyStep3',
      meta: {
        title: "ApplyStep3",
      },
      component: ApplyStep3
    },
    {
      path: '/applyStep4',
      meta: {
        title: "ApplyStep4",
      },
      component: ApplyStep4
    },
    {
      path: '/applyStep5',
      meta: {
        title: "ApplyStep5",
      },
      component: ApplyStep5
    },
    {
      path: '/lead',
      meta: {
        title: "Lead",
      },
      component: Lead
    },
    {
      path: '/index/',
      meta: {
        title: "Index",
        requireAuth: true, // 判断是否需要登录
      },
      component: Index,
      children: [
        {
          path: '/order',//我的订单
          meta: {
            title: "Order",
          },
          component: Order
        },
        {
          path: '/team',//我的团队
          meta: {
            title: "Team",
          },
          component: Team
        },
        {
          path: '/myHome',
          meta: {
            title: "MyHome",
          },
          component: MyHome
        },
        {
          path: '',
          meta: {
            title: "AgentHome",
          },
          component: AgentHome
        },
        {
          path: '/stock',
          meta: {
            requireAuth: true, // 判断是否需要登录
            title: "Stock",
          },
          component: Stock
        },
      ]
    },
    {
      path: '/teamInfo',//团队资料
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "TeamInfo",
      },
      component: TeamInfo
    },
    {
      path: '/teamNum',//团队人数
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "TeamNum",
      },
      component: TeamNum
    },
    {
      path: '/teamNewAdd',//新增人数
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "TeamNewAdd",
      },
      component: TeamNewAdd
    },
    {
      path: '/teamAchievement',//团队业绩
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "TeamAchievement",
      },
      component: TeamAchievement
    },
    {
      path: '/teamAchievementInfo',//团队业绩
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "TeamAchievementInfo",
      },
      component: TeamAchievementInfo
    },
    {
      path: '/teamAgentType',//代理层级
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "TeamAgentType",
      },
      component: TeamAgentType
    },
    {
      path: '/setUp',
      meta: {
        title: "SetUp",
        requireAuth: true, // 判断是否需要登录
      },
      component: SetUp
    },
    {
      path: '/myInfo',
      meta: {
        title: "MyInfo",
        requireAuth: true, // 判断是否需要登录
      },
      component: MyInfo
    },
    {
      path: '/updatePwd',
      meta: {
        title: "UpdatePwd",
        requireAuth: true, // 判断是否需要登录
      },
      component: UpdatePwd
    },
    {
      path: '/myAddress',
      meta: {
        title: "MyAddress",
        requireAuth: true, // 判断是否需要登录
      },
      component: MyAddress
    },
    {
      path: '/addAddress',
      meta: {
        title: "AddAddress",
        requireAuth: true, // 判断是否需要登录
      },
      component: AddAddress
    },
    {
      path: '/updateAddress',
      meta: {
        title: "UpdateAddress",
        requireAuth: true, // 判断是否需要登录
      },
      component: UpdateAddress
    },
    {
      path: '/myBank',
      meta: {
        title: "MyBank",
        requireAuth: true, // 判断是否需要登录
      },
      component: MyBank
    },
    {
      path: '/addMyBank',
      meta: {
        title: "AddMyBank",
        requireAuth: true, // 判断是否需要登录
      },
      component: AddMyBank
    },
    {
      path: '/myPayment',
      meta: {
        title: "MyPayment",
        requireAuth: true, // 判断是否需要登录
      },
      component: MyPayment
    },
    {
      path: '/alipay',
      meta: {
        title: "MyAlipay",
        requireAuth: true, // 判断是否需要登录
      },
      component: MyAlipay
    },
    {
      path: '/addAlipay',
      meta: {
        title: "AddAlipay",
        requireAuth: true, // 判断是否需要登录
      },
      component: AddAlipay
    },
    {
      path: '/weChat',
      meta: {
        title: "WeChat",
        requireAuth: true, // 判断是否需要登录
      },
      component: WeChat
    },
    {
      path: '/addWeChat',
      meta: {
        title: "AddWeChat",
        requireAuth: true, // 判断是否需要登录
      },
      component: AddWeChat
    },
    {
      path: '/transfer',
      meta: {
        title: "Transfer",
        requireAuth: true, // 判断是否需要登录
      },
      component: Transfer
    },
    {
      path: '/transfersuccess',
      meta: {
        title: "TransferSuccess",
        requireAuth: true, // 判断是否需要登录
      },
      component: TransferSuccess
    },
    {
      path: '/myAuth',
      meta: {
        title: "MyAuth",
        requireAuth: true, // 判断是否需要登录
      },
      component: MyAuth
    },
    {
      path: '/myOrders',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "MyOrders",
      },
      component: MyOrders,
    },{
      path: '/internalOrders',		
	    meta: {		
      	requireAuth: true, // 判断是否需要登录		
	     title: "InternalOrders",		
	     },		
	     component: InternalOrders,		
	    },		
	   {		
	    path: '/internalShop',		
	    meta: {		
	     requireAuth: true, // 判断是否需要登录		
	     title: "InternalShop",		
	     },		
	     component: InternalShop,		
	    },		   
    {
      path: '/twosubOrders',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "TwosubOrders",
      },
      component: TwosubOrders
    },
    {
      path: '/teamsubOrders',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "TeamsubOrders",
      },
      component: TeamsubOrders
    },
    {
      path: '/subOrders',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "SubOrders",
      },
      component: SubOrders
    },
    {
      path: '/orderDetails',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "OrderDetails",
      },
      component: OrderDetails
    },
    {
      path: '/actualStockDetail',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "ActualStockDetail",
      },
      component: ActualStockDetail
    },
    {
      path: '/virtualStockDetail',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "VirtualStockDetail",
      },
      component: VirtualStockDetail
    },
    {
      path: '/takeGoods',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "TakeGoods",
      },
      component: TakeGoods
    },
    {
      path: '/stockSubmitOrders',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "StockSubmitOrders",
      },
      component: StockSubmitOrders
    },
    {
      path: '/stockSubmitSuccess',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "StockSubmitSuccess",
      },
      component: StockSubmitSuccess
    },
    {
      path: '/stockOrderList',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "StockOrderList",
      },
      component: StockOrderList
    },
    {
      path: '/agentQuery',
      meta: {
        requireAuth: false, // 判断是否需要登录
        title: "AgentQuery",
      },
      component: AgentQuery
    },
    {
      path: '/auditOrders',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "AuditOrders",
      },
      component: AuditOrders
    },
    {
      path: '/auditOrdersDetail',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "AuditOrdersDetail",
      },
      component: AuditOrdersDetail
    },
    {
      path: '/transferDetails',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "TransferDetails",
      },
      component: TransferDetails
    },
    {
      path: '/agentQueryResult',
      meta: {
        requireAuth: false, // 判断是否需要登录
        title: "AgentQueryResult",
      },
      component: AgentQueryResult
    },
    {
      path: '/security',
      meta: {
        requireAuth: false, // 判断是否需要登录
        title: "Security",
      },
      component: Security
    },
    {
      path: '/securityResult',
      meta: {
        requireAuth: false, // 判断是否需要登录
        title: "SecurityResult",
      },
      component: SecurityResult
    },
    {
      path: '/myReward',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "MyReward",
      },
      component: MyReward
    },
    {
      path: '/QRDelivery',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "QRDelivery",
      },
      component: QRDelivery
    },
    {
      path: '/wallet',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "Wallet",
      },
      component: Wallet
    },
    {
      path: '/settlement',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "Settlement",
      },
      component: Settlement
    },
    {
      path: '/withdrawal',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "Withdrawal",
      },
      component: Withdrawal
    },
    {
      path: '/recharge',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "Recharge",
      },
      component: Recharge
    },
    {
      path: '/income',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "Income",
      },
      component: Income
    },
    {
      path: '/spending',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "Spending",
      },
      component: Spending
    },
    {
      path: '/upgrade',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "Upgrade",
      },
      component: Upgrade
    },
    {
      path: '/sweepCodeDelivery',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "SweepCodeDelivery",
      },
      component: SweepCodeDelivery
    },
    {
      path: '/DeliverySelectAgent',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "DeliverySelectAgent",
      },
      component: DeliverySelectAgent
    },
    {
      path: '/DeliveryLogisticsCode',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "DeliveryLogisticsCode",
      },
      component: DeliveryLogisticsCode
    },
    {
      path: '/expressInfo',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "expressInfo",
      },
      component: expressInfo
    },
    {
      path: '/deliveryRecord',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "DeliveryRecord",
      },
      component: DeliveryRecord
    },
    {
      path: '/deliveryRecordDetail',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "DeliveryRecordDetail",
      },
      component: DeliveryRecordDetail
    },
    {
      path: '/report',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "Report",
      },
      component: Report
    }, {
      path: '/message',         //消息页面
      meta: {
        requireAuth: true,  // 判断是否需要登录
        title: "Message",
      },
      component: Message
    }, {
      path: '/messagedetail',         //系统消息详情页面
      meta: {
        requireAuth: true,  // 判断是否需要登录
        title: "Messagedetail",
      },
      component: Messagedetail
    }, {
      path: '/updaterecord',   //升级记录页面
      meta: {
        requireAuth: true,  // 判断是否需要登录
        title: "Updaterecord",
      },
      component: Updaterecord
    }, {
      path: '/cashdeposit',   //保证金页面
      meta: {
        requireAuth: true,  // 判断是否需要登录
        title: "Cashdeposit",
      },
      component: Cashdeposit
    }, {
      path: '/paycashdeposit',   //缴纳保证金页面
      meta: {
        requireAuth: true,  // 判断是否需要登录
        title: "PayCashdeposit",
      },
      component: PayCashdeposit
    }, {
      path: '/uploadcashdeposit',   //保证金上传凭证页面
      meta: {
        requireAuth: true,  // 判断是否需要登录
        title: "UploadCashdeposit",
      },
      component: UploadCashdeposit
    }, {
      path: '/myshop',   //我的小店页面
      meta: {
        requireAuth: true,  // 判断是否需要登录
        title: "Myshop",
      },
      component: Myshop
    }, {
      path: '/myshopbuy',   //我的小店页面
      meta: {
        requireAuth: true,  // 判断是否需要登录
        title: "MyshopBuy",
      },
      component: MyshopBuy
    }, {
      path: '/clock',   //我的小店秒杀页面
      meta: {
        requireAuth: true,  // 判断是否需要登录
        title: "Clock",
      },
      component: Clock
    }, {
      path: '/clockedit',   //我的小店秒杀编辑页面
      meta: {
        requireAuth: true,  // 判断是否需要登录
        title: "ClockEdit",
      },
      component: ClockEdit
    }, {
      path: '/bargain',   //我的小店砍价页面
      meta: {
        requireAuth: true,  // 判断是否需要登录
        title: "Bargain",
      },
      component: Bargain
    }, {
      path: '/bargainedit',   //我的小店砍价编辑页面
      meta: {
        requireAuth: true,  // 判断是否需要登录
        title: "BargainEdit",
      },
      component: BargainEdit
    }, {
      path: '/groupshopping',   //我的小店拼团页面
      meta: {
        requireAuth: true,  // 判断是否需要登录
        title: "GroupShopping",
      },
      component: GroupShopping
    }, {
      path: '/groupshoppingedit',   //我的小店拼团编辑页面
      meta: {
        requireAuth: true,  // 判断是否需要登录
        title: "GroupShoppingEdit",
      },
      component: GroupShoppingEdit
    }, {
      path: '/productdetail',   //商品详情页
      meta: {
        title: "ProductDetail",
      },
      component: ProductDetail
    },  {
      path: '/productdetailgroupshopping',   //商品详情页-团购活动
      meta: {
        title: "ProductDetail",
      },
      component: ProductDetailGroupShopping
    },  {
      path: '/productdetailclock',   //商品详情页-秒杀活动
      meta: {
        title: "ProductDetail",
      },
      component: ProductDetailClock
    },  {
      path: '/productdetailbargain',   //商品详情页-砍价活动
      meta: {
        title: "ProductDetail",
      },
      component: ProductDetailBargain
    },  {
      path: '/myshopsubmitorders',   //小店-订单提交
      meta: {
        title: "MyshopSubmitOrders",
      },
      component: MyshopSubmitOrders
    }, 
    {
      path: '/myshopsubmitorderssuccess',   //小店-订单提交
      meta: {
        title: "MyshopSubmitOrdersSuccess",
      },
      component: MyshopSubmitOrdersSuccess
    },
    {
      path: '/myshopaddress',   //小店-地址页面
      meta: {
        title: "MyshopAddress",
      },
      component: MyshopAddress
    },  {
      path: '/myshopaddressadd',   //小店-地址添加
      meta: {
        title: "MyshopAddressAdd",
      },
      component: MyshopAddressAdd
    },  {
      path: '/myshopaddressupdate',   //小店-地址更新
      meta: {
        title: "MyshopAddressUpdate",
      },
      component: MyshopAddressUpdate
    },
     {
      path: '/remind',   //待办提醒页
      meta: {
        requireAuth: true,  // 判断是否需要登录
        title: "Remind",
      },
      component: Remind
    }, {
      path: '/promote',   //推广
      meta: {
        requireAuth: true,  // 判断是否需要登录
        title: "Promote",
      },
      component: Promote
    }, {
      path: '/promotedetail',   //推广详情
      meta: {
        requireAuth: true,  // 判断是否需要登录
        title: "PromoteDetail",
      },
      component: PromoteDetail
    }, {
      path: '/sourcecenter',   //素材中心
      meta: {
        requireAuth: true,  // 判断是否需要登录
        title: "SourceCenter",
      },
      component: SourceCenter
    }, {
      path: '/sourcedetail', //素材详情
      meta: {
        requireAuth: true,  // 判断是否需要登录
        title: "SourceDetail",
      },
      component: SourceDetail
    }, {
      path: '/mysource', //我的素材
      meta: {
        requireAuth: true,  // 判断是否需要登录
        title: "MySource",
      },
      component: MySource
    }, {
      path: '/subTransfer',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "SubTransfer",
      },
      component: SubTransfer
    },
     {
      path: '/SubTransferAgents',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "SubTransferAgents",
      },
      component: SubTransferAgents
    },
     {
      path: '/subTransferAudit',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "subTransferAudit",
      },
      component: SubTransferAudit
    },
    {
      path: '/monthReward',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "MonthReward",
      },
      component: MonthReward
    },
    {
      path: '/onceReward',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "OnceReward",
      },
      component: OnceReward
    },
    {
      path: '/upgradeReward',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "UpgradeReward",
      },
      component: UpgradeReward
    },
    {
      path: '/topLevelPushReward',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "TopLevelPushReward",
      },
      component: TopLevelPushReward
    },
    {
      path: '/noTopLevelPushReward',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "NoTopLevelPushReward",
      },
      component: NoTopLevelPushReward
    },
    {
      path: '/orderReward',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "OrderReward",
      },
      component: OrderReward
    },
    {
      path: '/spendingReward',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "SpendingReward",
      },
      component: SpendingReward
    },
    {
      path: '/withdrawalReward',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "WithdrawalReward",
      },
      component: WithdrawalReward
    },
    {
      path: '/paymentCert',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "PaymentCert",
      },
      component: PaymentCert
    },
    {
      path: '/walletWithdrawal',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "WalletWithdrawal",
      },
      component: WalletWithdrawal
    },
    {
      path: '/AchievementDatails',
      meta: {
        requireAuth: true, // 判断是否需要登录
        title: "AchievementDatails",
      },
      component: AchievementDatails
    },
    {
      path: '/certification',
      meta: {
        title: "Certification",
        requireAuth: true, // 判断是否需要登录
      },
      component: Certification
    },
    {
      path: '/certificationInfo',
      meta: {
        title: "CertificationInfo",
        requireAuth: true, // 判断是否需要登录
      },
      component: CertificationInfo
    },
    {
      path: '/delOpenid',
      meta: {
        title: "DelOpenid",
        requireAuth: true, // 判断是否需要登录
      },
      component: DelOpenid
    },
    {
      path: '/searchAnticodeCode',
      meta: {
        title: "searchAnticodeCode",
        requireAuth: true, // 判断是否需要登录
      },
      component: searchAnticodeCode
    },
    {
      path: '/skuPriceSheet',
      meta: {
        title: "SkuPriceSheet",
        requireAuth: true, // 判断是否需要登录
      },
      component: SkuPriceSheet
    },
    {
      path: '/shareSkuPriceSheet',
      meta: {
        title: "SkuPriceSheet",
        requireAuth: false, // 判断是否需要登录
      },
      component: ShareSkuPriceSheet
    },
    {
      path: '/orderLogistics',
      meta: {
        title: "OrderLogistics",
        requireAuth: true, // 判断是否需要登录
      },
      component: OrderLogistics
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js